import { render } from "./DataSubscriptions.vue?vue&type=template&id=6c011864&scoped=true"
import script from "./DataSubscriptions.vue?vue&type=script&lang=js"
export * from "./DataSubscriptions.vue?vue&type=script&lang=js"

import "./DataSubscriptions.vue?vue&type=style&index=0&id=6c011864&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c011864"]])

export default __exports__